////////////////////

import base_module from '@/vue-model-mirror/stores/base_v2.module';
import axios from 'axios';

const config = require('../config.js')[ process.env.NODE_ENV ];

var options = {
    model_name    : 'rwassignment',
    send_alert    : false,
    default_order : 'id ASC',
};

var base = new base_module( options );

const state = {
    ...base.state,
    filters : {},
};

const getters = {
    ...base.getters,
}

const actions = {
    ...base.actions,
};

const mutations = {
    ...base.mutations,
}

export default {
    namespaced : true,
    ...base,
    state,
    actions,
    mutations,
    getters,
};

